import React from 'react'
import { Layout } from '../components/Shared'
import { WORKSHOP_XR_INTRO_URL } from '../utils/url'

const PricingPage = ({ width }) => (
  <Layout>
    <div
      style={{
        maxWidth: 720,
        margin: '0 auto',
        padding: '120px 24px 160px',
        textAlign: 'center',
        fontFamily: 'irisvr',
      }}
    >
      <h1
        style={{
          fontSize: 36,
          fontWeight: 'bold',
          color: '#000000',
          marginBottom: 24,
          lineHeight: 1.2,
        }}
      >
        Prospect is no longer available for sale
      </h1>
      <p
        style={{
          fontSize: 18,
          color: '#333333',
          lineHeight: 1.6,
          marginBottom: 32,
        }}
      >
        From the team who brought you Prospect by IrisVR:{' '}
        <a
          href={WORKSHOP_XR_INTRO_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#534DC9', fontWeight: 'bold' }}
        >
          Autodesk Workshop XR
        </a>
        , an immersive design review workspace for AEC teams.
      </p>
      <a
        href={WORKSHOP_XR_INTRO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="iris-cta-button"
        style={{ display: 'inline-block', textDecoration: 'none' }}
      >
        Learn about Workshop XR
      </a>
    </div>
  </Layout>
)

export default PricingPage
